// Printer connection types


export interface PrinterConfig {
  encoding: string;
  width: number;
  commands: number[];
}

export interface PrintCommand {
  command: string;
  bytes: number[];
}

export interface ReceiptItem {
  name: string;
  price: number;
}

export const ESC_POS = {
    // Basic
    INIT: [0x1B, 0x40],
    LF: [0x0A],
    CR: [0x0D],
    CANCEL: [0x18],
  
    // Text
    FONT_A: [0x1B, 0x4D, 0x00],
    FONT_B: [0x1B, 0x4D, 0x01],
    BOLD_ON: [0x1B, 0x45, 0x01],
    BOLD_OFF: [0x1B, 0x45, 0x00],
    ALIGN_LEFT: [0x1B, 0x61, 0x00],
    ALIGN_CENTER: [0x1B, 0x61, 0x01],
    ALIGN_RIGHT: [0x1B, 0x61, 0x02],
    HEADER:[ 0x1D, 0x21, 0x11,],
    TEXT:[ 0x1D, 0x21, 0x00,],
    DOUBLE_WIDTH:[ 0x1D, 0x21, 0x10,],


  
    // Paper
    CUT_PARTIAL: [0x1B, 0x69],
    CUT_FULL: [0x1D, 0x56, 0x00],
    FEED_LINES: (n: number) => [0x1B, 0x64, n],
  
    // Barcode (Simplified)
    BARCODE_CODE39: [0x1D, 0x6B, 0x04],  OPEN_DRAWER: [0x1B, 0x70, 0x00, 0x50, 0x50]
} as const;
